import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { MultiDepositSteps } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/multiDepositJourney/MultiDepositSteps.state';
import { DepositErrorMessagesState } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/errorMessages/DepositErrorMessages.state';
import { DepositTabWrapper } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/DepositProcedure.style';
import { WorldpayTabState } from './WorldpayTab.state';
import { WorldpayFrame } from './WorldpayFrame';
import { WorldpayChallenge } from './WorldpayChallenge';
import { WorldpayLoaderWrapper } from './WorldpayTab.style';

interface WorldpayTabPropsType {
    amount: string;
    paymentMethod: 'debit-card' | 'apple-pay' | 'google-pay';
    stepsState: MultiDepositSteps;
    isSignup: boolean;
    errorMessagesState: DepositErrorMessagesState;
}

export const WorldpayTab = observer(
    'WorldpayTab',
    ({ amount, paymentMethod, stepsState, isSignup, errorMessagesState }: WorldpayTabPropsType): JSX.Element => {
        const common = useCommon();
        const [state] = useState(
            () => new WorldpayTabState(common, amount, paymentMethod, stepsState, isSignup, errorMessagesState)
        );

        React.useEffect(() => {
            void state.loadSavedPaymentMethods();
        }, [state]);

        const showLoader = paymentMethod === 'debit-card' && state.isSdkReady === false;

        if (state.challengeData !== null) {
            return (
                <DepositTabWrapper>
                    <WorldpayChallenge state={state} />
                </DepositTabWrapper>
            );
        }

        return (
            <DepositTabWrapper>
                {showLoader ? <WorldpayLoaderWrapper size={24} /> : null}
                <WorldpayFrame
                    state={state}
                    hidden={showLoader}
                    paymentMethod={paymentMethod}
                />
            </DepositTabWrapper>
        );
    }
);
